import { render } from "./topicSignCheck.vue?vue&type=template&id=0d6be75a&scoped=true"
import script from "./topicSignCheck.vue?vue&type=script&lang=js"
export * from "./topicSignCheck.vue?vue&type=script&lang=js"

import "./topicSignCheck.vue?vue&type=style&index=0&id=0d6be75a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6be75a"]])

export default __exports__